import React from "react";
import HeroCarousel from "@components/HeroCarousel";
import ServicesOverview from "@components/ServicesOverview";
import SEO from "@components/SEO";
import { heroSlides } from "@data/heroSlides";
import { companyInfo } from "@data/companyInfo";
import {
  createWebsiteStructuredData,
  createBusinessStructuredData,
} from "../utils/structuredData";
import {
  BookOpenIcon,
  HeartIcon,
  CheckBadgeIcon,
} from "@heroicons/react/24/solid";

const HomePage: React.FC = () => {
  const structuredData = [
    createWebsiteStructuredData(),
    createBusinessStructuredData(companyInfo),
  ];

  return (
    <div>
      <SEO
        title="New Zealand Tour Packages from Malaysia | Ikhlas Tours"
        description="Customisable New Zealand tour packages from Malaysia. Muslim-friendly North Island, South Island and combo itineraries with NZ-based local guides and 24/7 support."
        image="/assets/IMG_8397.JPG"
        path="/"
        structuredData={structuredData}
      />
      <HeroCarousel slides={heroSlides} />
      <ServicesOverview />

      {/* Additional Home Content */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-primaryText mb-4">
              Why Choose Ikhlas Tours?
            </h2>
            <p className="text-xl text-gray-600 max-w-4xl mx-auto">
              Experience New Zealand with local experts who care about your
              journey as much as you do
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="bg-primary rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <BookOpenIcon className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-semibold text-primaryText mb-2">
                Local Expertise
              </h3>
              <p className="text-gray-600">
                13+ years of experience showing travelers the real New Zealand
              </p>
            </div>

            <div className="text-center">
              <div className="bg-primary rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <CheckBadgeIcon className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-semibold text-primaryText mb-2">
                Personalized Service
              </h3>
              <p className="text-gray-600">
                Tailored experiences that match your interests and travel style
              </p>
            </div>

            <div className="text-center">
              <div className="bg-primary rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <HeartIcon className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-semibold text-primaryText mb-2">
                Kiwi-Malaysian Hospitality
              </h3>
              <p className="text-gray-600">
                Blending warm Kiwi friendliness with Malaysian Muslim-friendly
                care for your perfect travel experience
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-16 bg-tertiary">
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Ready for Your New Zealand Adventure?
          </h2>
          <p className="text-xl text-white mb-8">
            Let our team help you create memories that will last a lifetime
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/tours"
              className="inline-block bg-primary text-white px-8 py-3 rounded-md font-semibold hover:bg-opacity-90 transition-all duration-300"
            >
              Explore Tours
            </a>
            <a
              href="/contact"
              className="inline-block bg-white text-primary px-8 py-3 rounded-md font-semibold hover:bg-gray-100 transition-all duration-300"
            >
              Contact Us
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
